import { toman } from 'utilities/helper/format'

/**
 * «توضیح و مرور» — the last step.
 *
 * The note is optional but pushed hard, because it is the only channel the
 * member has. There is no rejection and no negotiation in this flow: a manager
 * looking at «۲ میلیون» and a manager looking at «۲ میلیون — شهریهٔ دانشگاه،
 * تا آخر ماه» are making different decisions about the same request, and the
 * second one is the decision the fund exists to make.
 */
export default function StepReview({
    fundName,
    amount,
    capital,
    debt,
    partialAccepted,
    cardLabel,
    note,
    onNoteChange,
}: {
    fundName: string
    amount: number
    capital: number
    debt: number
    partialAccepted: boolean
    cardLabel: string | null
    note: string
    onNoteChange: (value: string) => void
}) {
    return (
        <div className=" flex flex-col gap-3">
            <div className=" rounded-2xl border border-stroke bg-white p-4">
                <Row label="صندوق" value={fundName} />
                <Row label="سرمایهٔ شما" value={toman(capital)} />
                <Row label="مبلغ درخواست" value={toman(amount)} bold />
                <Row
                    label="پرداخت بخشی"
                    value={partialAccepted ? 'قابل قبول است' : 'قابل قبول نیست'}
                />
                <Row label="واریز به" value={cardLabel ?? 'مشخص نشده'} last />
            </div>

            {debt > 0 && (
                <div className=" rounded-2xl bg-warning-soft px-3 py-3 text-[11px] leading-6 text-warning-on">
                    یادآوری: شما {toman(debt)} بابت اقساط پرداخت‌نشده به این
                    صندوق بدهکار هستید. این مانع ثبت درخواست نیست و مدیر تصمیم
                    می‌گیرد.
                </div>
            )}

            <div className=" rounded-2xl border border-stroke bg-white p-4">
                <label
                    htmlFor="withdrawal-note"
                    className=" block text-sm font-bold text-heading"
                >
                    چرا به این پول نیاز دارید؟
                </label>
                <p className=" mt-1 text-[11px] leading-6 text-text-secondary">
                    اختیاری، ولی خیلی کمک می‌کند. مدیر صندوق فقط همین را از شما
                    می‌بیند.
                </p>
                <textarea
                    id="withdrawal-note"
                    value={note}
                    onChange={(event) => onNoteChange(event.target.value)}
                    rows={3}
                    maxLength={500}
                    placeholder="مثلاً: شهریهٔ دانشگاه، تا آخر ماه لازم دارم"
                    className=" mt-3 w-full resize-none rounded-xl border border-stroke bg-canvas px-3 py-2 text-xs leading-6 text-text-body outline-none focus:border-brand"
                />
            </div>

            <p className=" px-1 text-[11px] leading-6 text-text-muted">
                با ثبت این درخواست از صندوق خارج نمی‌شوید و عضویتتان دست‌نخورده
                می‌ماند. مدیران صندوق پیامک می‌گیرند و شما هر پرداخت را همین‌جا
                می‌بینید. هر وقت بخواهید می‌توانید درخواست را ببندید.
            </p>
        </div>
    )
}

function Row({
    label,
    value,
    bold,
    last,
}: {
    label: string
    value: string
    bold?: boolean
    last?: boolean
}) {
    return (
        <div
            className={` flex items-center justify-between gap-2 py-2 ${
                last ? '' : ' border-b border-divider'
            }`}
        >
            <span className=" text-[11px] text-text-secondary">{label}</span>
            <span
                className={` truncate text-xs ${
                    bold ? ' font-bold text-heading' : ' text-text-body'
                }`}
            >
                {value}
            </span>
        </div>
    )
}
